import { AnalyticsBrowser } from '@segment/analytics-next';
import appConfig from '../../shared/config/appConfig';

const args = {
  writeKey: appConfig.segmentWriteKey,
};

export const analytics = AnalyticsBrowser.load(args);
